<template>
  <el-dialog
    class="rc-dialog"
    width="50%"
    :title="title"
    :visible.sync="isShow"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <el-form
      ref="editForm"
      :model="editObject"
      size="small"
      :rules="rules"
      label-width="100px"
      label-position="right"
      class="form"
    >
      <el-row :gutter="12">
        <el-col>
          <el-form-item label="版本编号：" prop="versionCode">
            <el-input
              v-model="editObject.versionCode"
              placeholder="请输入版本编号"
            />
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item label="版本名称：" prop="versionName">
            <el-input
              v-model="editObject.versionName"
              placeholder="请输入版本名称"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item label="文件路径：" prop="filePath">
            <el-input
              v-model="editObject.filePath"
              placeholder="请输入文件路径"
            ></el-input>
          </el-form-item>

        </el-col>
        <el-col>
          <el-form-item label="版本类型：" prop="versionType">
            <el-radio-group v-model="editObject.versionType">
              <el-radio
                v-for="item in versionTypeMap"
                :key="item.paramKey"
                :label="item.paramKey"
                >{{ item.paramValue }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item label="强制升级：" prop="upgrade">
            <el-radio-group v-model="editObject.upgrade">
              <el-radio
                v-for="item in upgradeMap"
                :key="item.paramKey"
                :label="item.paramKey"
                >{{ item.paramValue }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
        </el-col>
         <el-col>
          <el-form-item label="定向配置：" prop="partUser">
            <el-radio-group v-model="editObject.partUser">
              <el-radio
                v-for="item in upgradeMap"
                :key="item.paramKey"
                :label="item.paramKey"
                >{{ item.paramValue }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col v-if="editObject.partUser == 1">
          <el-form-item label="指定账户：" prop="userMobile">
            <el-input
                  type="textarea"
                  :rows="3"
                  placeholder="请输入手机号，用逗号隔开"
                  maxlength="500"
                  show-word-limit
                  v-model="editObject.userMobile">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item label="更新内容：" prop="versionContent">
            <el-input
                    type="textarea"
                    :rows="6"
                    placeholder="请输入更新内容"
                    maxlength="500"
                    show-word-limit
                    v-model="editObject.versionContent">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <butn @click.native="closeFrom()" btntype title="取消"></butn>
      <butn btntype="primary" @click.native="submitForm()" title="确定"></butn>
    </div>
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";
import Bus from "./Bus";
import { versionSave, versionUpdate, versionInfo } from "@/api/sysVersion";
import { getSysParamByTypes } from "@/api/sysParam";

export default {
  name: "curd",
  components: { butn },
  data() {
    return {
      isShow: false,
      title: "",
      versionTypeMap: [],
      upgradeMap: [],
      partUserMap: [],
      editObject: {
        versionCode: "",
        versionName: "",
        filePath: "",
        versionType: "0",
        upgrade: "0",
        versionContent: '',
        partUser: "0"
      },
      rules: {
        versionCode: [
          { required: true, message: "请输入版本编号" },
          { max: 20, message: "长度在 20 个字符以内" }
        ],
        versionName: [
          { required: true, message: "请输入版本名称", trigger: "blur" },
          { max: 50, message: "长度在 50 个字符以内" }
        ],
        filePath: [
          { required: true, message: "请输入文件路径", trigger: "blur" },
          { max: 255, message: "长度在 255 个字符以内" }
        ],
        versionType: [
          { required: true, message: "请输入版本类型", trigger: "blur" }
        ],
        upgrade: [
          { required: true, message: "请输入升级方式", trigger: "blur" }
        ],
        partUser: [
          { required: true, message: "请选择是否需要定向配置", trigger: "blur" }
        ],
        versionContent: [
          { required: true, message: "请输入版本内容", trigger: "blur" },
          { max: 500, message: "长度在 500 个字符以内" }
        ]
      }
    };
  },
  methods: {
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({types: types}).then((res) => {
        if (!res || res.code != 0) return;
        this.versionTypeMap = res.data["VERSION_TYPE"] || [];
        this.upgradeMap = res.data["IS_VALID"] || [];
        this.partUserMap = res.data["IS_VALID"] || [];
      });
    },
    closeFrom() {
      this.$refs["editForm"].resetFields();
      this.isShow = false;
      // 点击取消 数据重置
    },
    handleClose() {
      this.$refs["editForm"].resetFields();
      this.editObject = {};
    },
    showFrom(msg) {
      this.isShow = true;
      this.title = msg;
    },
    submitForm() {
      this.$refs["editForm"].validate(valid => {
        if (valid) {
          if (!this.editObject.uuid) {
            // 新增
            versionSave(this.editObject).then(res => {
              if (!res || res.code != 0) return;
              Bus.$emit("reload");
              this.closeFrom();
            });
          } else {
            //编辑
            versionUpdate(this.editObject).then(res => {
              if (!res || res.code != 0) return;
              Bus.$emit("reload");
              this.closeFrom();
            });
          }
        }
      });
    }
  },
  created() {
    this.getSysParamByTypes(["VERSION_TYPE", "IS_VALID"]);

    Bus.$on("addVersion", () => {
      this.$set(
        this.editObject,
        "versionType",
        this.versionTypeMap[0].paramKey + ""
      );
      this.$set(this.editObject, "upgrade", this.upgradeMap[0].paramKey + "");
      this.$set(this.editObject, "partUser", this.partUserMap[0].paramKey + "");
      this.showFrom("新增");
    });
    Bus.$on("updateVersion", row => {
      this.editObject.uuid = row.uuid;
      versionInfo(row.uuid).then(res => {
        if (!res || res.code != 0) return;
        this.editObject = res.data;
        this.editObject.versionType = res.data.versionType + "";
        this.editObject.upgrade = res.data.upgrade + "";
        this.editObject.partUser = res.data.partUser + "";
        this.editObject.versionContent = res.data.versionContent;
        this.showFrom("编辑");
      });
    });
  },
  beforeDestroy() {
    Bus.$off("addVersion");
    Bus.$off("updateVersion");
  }
};
</script>

<style lang="scss" scoped></style>>
